if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton ? this.submitButton.querySelector('span') : null;
        if (document.querySelector('cart-drawer') && this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }
        this.hideerrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        
        // Validate required fields
        if (!this.form.checkValidity()) {
          this.form.reportValidity();
          return;
        }
        
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        const loadingSpinner = this.querySelector('.loading__spinner');
        if (loadingSpinner) loadingSpinner.classList.remove('hidden');

        const formData = new FormData(this.form);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description || response.message);
              const soldOutMessage = this.submitButton ? this.submitButton.querySelector('.sold-out-message') : null;
              if (soldOutMessage && this.submitButtonText) {
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButtonText.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
              }
              this.resetButtonState();
              return;
            }

            // Success - update cart count immediately
            this.fetchCartAndUpdate();
            
            // Open cart notification/drawer if exists
            if (this.cart && typeof this.cart.open === 'function') {
              this.cart.open();
            }
            
            this.resetButtonState();
          })
          .catch((e) => {
            console.error('Cart add error:', e);
            this.resetButtonState();
            this.handleErrorMessage('Unable to add item to cart. Please try again.');
          });
      }

      fetchCartAndUpdate() {
        fetch('/cart.js')
          .then((response) => response.json())
          .then((cart) => {
            this.updateCartCount(cart.item_count);
            if (this.cart && typeof this.cart.renderContents === 'function') {
              this.cart.renderContents(cart);
            }
          })
          .catch((e) => console.error('Failed to fetch cart:', e));
      }

      resetButtonState() {
        if (this.submitButton) {
          this.submitButton.setAttribute('aria-disabled', false);
          this.submitButton.classList.remove('loading');
        }
        const loadingSpinner = this.querySelector('.loading__spinner');
        if (loadingSpinner) loadingSpinner.classList.add('hidden');
      }

      updateCartCount(itemCount) {
        // Update all possible cart count elements
        const selectors = [
          '.cart-count-bubble span',
          '#cart-icon-bubble',
          '[data-cart-count]',
          'cart-notification .cart-count',
          'cart-drawer .cart-count',
          '.cart-count'
        ];
        
        selectors.forEach(selector => {
          const elements = document.querySelectorAll(selector);
          elements.forEach(element => {
            element.textContent = itemCount;
            if (itemCount > 0) {
              element.classList.remove('hidden');
              if (element.parentElement) {
                element.parentElement.classList.remove('hidden');
              }
            }
          });
        });

        // Update cart drawer state
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          if (itemCount > 0) {
            cartDrawer.classList.remove('is-empty');
          } else {
            cartDrawer.classList.add('is-empty');
          }
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideerrors) return;
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}